module.exports = __webpack_public_path__ + "img/bee-single.cf7f8043.svg";